import { FC } from "react";

import SalesChannelContainer from "@app/containers/salesChannel";

const AddSalesChannelPage: FC = () => <SalesChannelContainer />;

export default AddSalesChannelPage;
